import { TreeCardObject } from '../tree-card/tree-card-object.model';
import { OrderStatusObject } from '../order-status-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderTypeObject } from '../order-type-object.model';

export class ProductOrderObject extends TreeCardObject {

  constructor(name: string, completed: boolean, crmId: string, operation: string,
    status: string, dependencies: boolean, orderId: string) {
    super(name, 'ORDEN DE PRODUCTO', StringUtils.NOT_AVALIABLE, completed, crmId, operation,
      OrderStatusObject.createWithStatus(status), dependencies, 1, orderId, OrderTypeObject.PRODUCT);
    return this;
  }
}
